import { render, staticRenderFns } from "./TermsComponent.vue?vue&type=template&id=e61a65e4&scoped=true&"
import script from "./TermsComponent.vue?vue&type=script&lang=js&"
export * from "./TermsComponent.vue?vue&type=script&lang=js&"
import style0 from "./TermsComponent.vue?vue&type=style&index=0&id=e61a65e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61a65e4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VSpacer,VToolbar,VToolbarTitle})
